import { useEffect } from "react";
import { useDisclosure } from "@chakra-ui/react";
import useQueryParam, { QUERY_STRING_KEYS } from "hooks/useQueryParam";

const useOpenFormWithQueryParam = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formOpen, setFormOpen] = useQueryParam(QUERY_STRING_KEYS.FORM_OPEN);

  const handleOpen = () => {
    onOpen();
    if (formOpen !== "true") {
      setFormOpen("true");
    }
  };

  const handleClose = () => {
    onClose();
    if (formOpen !== null) {
      setFormOpen(null);
    }
  };

  // Sync internal state with query param
  useEffect(() => {
    if (formOpen === "true" && !isOpen) {
      onOpen();
    } else if (formOpen !== "true" && isOpen) {
      onClose();
    }
  }, [isOpen, onOpen, onClose, formOpen]);

  return { isOpen, handleOpen, handleClose };
};

export default useOpenFormWithQueryParam;
